<k-cards [size]="size" [isResponsive]="isResponsive">
    <div class="card-content h-full w-full" (click)="click()">
        <div class="coin-pic-container">
            <img class="coin-pic" [src]="data.pic" />
        </div>
        <div class="golden-label">
            <div class="text">
                {{data.goldenLabel}}</div>
        </div>
        <div class="footer">
            <div class="title-label-wrapper">
                <div class="title">{{data.title}}</div>
            </div>
            <div class="amount-wrapper">
                <div class="gradient-label">
                    <span>
                        {{data.dollarAmount}}
                    </span>
                </div>

                <div class="currency-icon">
                    <img src="./assets/img/Home/k-logo.png">
                </div>

                <div class="sm-amount">
                    {{data.KMONAmount}}
                </div>
                <k-divider class="divider" isVertical="true"></k-divider>
                <div class="currency-icon">
                    <img src="./assets/img/Icon/Cur-BNB.png">
                </div>

                <div class="sm-amount">
                    {{data.BNBAmount}}
                </div>
            </div>
        </div>
    </div>
</k-cards>